module.exports = __webpack_public_path__ + "static/img/19.05edbf90.png";